export default __webpack_public_path__ + "static/media/payment.c68a22c9.svg";